import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/ai/means-test']['GET'];
type Input = THIS_API['query'];
type Output = THIS_API['response'];

const getMeansTestData = async ({ userWorkflowId, documentRequestUserId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/ai/means-test');
  const response = await noodleApiClient.get(path, {params: { documentRequestUserId, userWorkflowId }});
  return response.data;
};

export default getMeansTestData;